import styled from 'styled-components'

export const HR = styled.hr`
    border-top: 1px solid #efefef;
    margin-bottom: 15px;
`
